const DEFAULT_SPACING = { top: "md", bottom: "md" };
const spacing = {
  type: Object,
  default: () => DEFAULT_SPACING
};
export { spacing, DEFAULT_SPACING };
